import { j as e } from "./jsx-runtime-C5mzlN2N.js";
import { C as k } from "./ClientOnly-E7hGysn1.js";
import { VisuallyHidden as v } from "@radix-ui/react-visually-hidden";
import { u as N, e as y, m as j, o as _, f as L } from "./hook-BwOB_iZo.js";
import { useRef as S, useLayoutEffect as T, useState as w } from "react";
import { B as E } from "./Button-Bdk_Ij3U.js";
import { C as R, a as f, b as p, c as F, d as I, e as q, f as P } from "./Callout-XadUe37J.js";
import { b as $ } from "./Dialog-CNf2oWXG.js";
import { S as A } from "./RouteGuard-lkdEJoDV.js";
import { BracketsIcon as D, FileTextIcon as O } from "lucide-react";
import { a as B, L as g } from "./chunk-BAXFHI7N-C9WnHsLV.js";
const U = async ({
  search: r,
  options: a,
  auth: n,
  context: i
}) => {
  const o = a.maxResults ?? 10, s = a.transformResults ?? (() => !0), t = [], c = z({
    search: r,
    transformFn: s,
    auth: n,
    context: i
  });
  for await (const l of c)
    if (t.push(l), t.length >= o) break;
  return t;
};
async function* z({
  search: r,
  transformFn: a,
  auth: n,
  context: i
}) {
  let s = 0;
  for (; s < r.results.length; ) {
    const t = r.results.slice(
      s,
      s + 5
    );
    s += t.length;
    const c = await Promise.all(t.map((l) => l.data()));
    for (const l of c) {
      const d = a({ result: l, auth: n, context: i });
      d !== !1 && (d === !0 || d == null ? yield l : yield d);
    }
  }
}
const G = (r, a) => {
  const n = r.weighted_locations.reduce(
    (o, s) => o + s.balanced_score,
    0
  );
  return a.weighted_locations.reduce(
    (o, s) => o + s.balanced_score,
    0
  ) - n;
}, x = "cursor-pointer border border-transparent data-[selected=true]:border-border", H = ({
  searchResults: r,
  searchTerm: a,
  onClose: n,
  maxSubResults: i = 4
}) => {
  const o = B(), s = S(null);
  return T(() => {
    requestIdleCallback(() => {
      s.current?.scrollTo({ top: 0 });
    });
  }, [a]), /* @__PURE__ */ e.jsxs(R, { className: "max-h-[450px]", ref: s, children: [
    a && r.length > 0 && /* @__PURE__ */ e.jsx(
      f,
      {
        className: "text-sm text-muted-foreground",
        heading: `${r.length} results for "${a}"`
      }
    ),
    a && r.map((t) => /* @__PURE__ */ e.jsxs(
      f,
      {
        children: [
          /* @__PURE__ */ e.jsx(
            p,
            {
              asChild: !0,
              value: `${t.meta.title}-${t.url}`,
              className: x,
              onSelect: () => {
                o(t.url), n();
              },
              children: /* @__PURE__ */ e.jsxs(g, { to: t.url, children: [
                t.meta.section === "openapi" ? /* @__PURE__ */ e.jsx(D, {}) : /* @__PURE__ */ e.jsx(O, {}),
                t.meta.title
              ] })
            }
          ),
          t.sub_results.sort(G).slice(0, i).map((c) => /* @__PURE__ */ e.jsx(
            p,
            {
              asChild: !0,
              value: `sub-${t.meta.title}-${c.url}`,
              className: x,
              onSelect: () => {
                o(c.url), n();
              },
              children: /* @__PURE__ */ e.jsx(g, { to: c.url, onClick: n, children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-start gap-2 ms-2.5 ps-5 border-l border-muted-foreground/50", children: [
                /* @__PURE__ */ e.jsx("span", { className: "font-bold", children: c.title }),
                /* @__PURE__ */ e.jsx(
                  "span",
                  {
                    className: "text-[13px] [&_mark]:bg-primary [&_mark]:text-primary-foreground",
                    dangerouslySetInnerHTML: { __html: c.excerpt }
                  }
                )
              ] }) })
            },
            `sub-${t.meta.title}-${c.url}`
          ))
        ]
      },
      [t.meta.title ?? t.excerpt, t.url].join("-")
    ))
  ] });
}, m = {
  // Slightly lower than default because API docs tend to have repetitive terms (parameter names, HTTP methods, etc.)
  termFrequency: 0.8,
  // Lower than default because API documentation pages tend to be longer due to comprehensive endpoint documentation
  pageLength: 0.6,
  // Slightly higher than default because in technical documentation, exact matches should be prioritized
  termSimilarity: 1.2,
  // Slightly lower than default because API docs might have legitimate repetition of terms
  termSaturation: 1.2
}, K = (r) => import(
  /* @vite-ignore */
  L(r, "/pagefind/pagefind.js")
), V = (r) => {
  const {
    options: { basePath: a }
  } = y(), { data: n, ...i } = j({
    queryKey: ["pagefind", r.ranking],
    retry: !1,
    queryFn: async () => {
      const o = await K(a);
      return await o.init(), await o.options({
        ranking: {
          termFrequency: r.ranking?.termFrequency ?? m.termFrequency,
          pageLength: r.ranking?.pageLength ?? m.pageLength,
          termSimilarity: r.ranking?.termSimilarity ?? m.termSimilarity,
          termSaturation: r.ranking?.termSaturation ?? m.termSaturation
        }
      }), o;
    },
    enabled: typeof window < "u"
  });
  return i.isError && i.error.message !== "NOT_BUILT_YET" && console.error(i.error), { ...i, pagefind: n };
}, Y = ({
  isOpen: r,
  onClose: a,
  options: n
}) => {
  const { pagefind: i, error: o, isError: s } = V(n), [t, c] = w(""), l = N(), d = y(), u = S(null), { data: b } = j({
    queryKey: ["pagefind-search", t, l.isAuthenticated],
    queryFn: async () => {
      const C = l.isAuthenticated ? void 0 : { not: { section: A } }, h = await i?.search(t, { filters: C });
      return h ? U({ search: h, options: n, auth: l, context: d }) : [];
    },
    placeholderData: _,
    enabled: !!i && !!t
  });
  return /* @__PURE__ */ e.jsxs(
    F,
    {
      command: { shouldFilter: !1 },
      content: { className: "max-w-[750px]" },
      open: r,
      onOpenChange: a,
      children: [
        /* @__PURE__ */ e.jsx(v, { children: /* @__PURE__ */ e.jsx($, { children: "Search" }) }),
        /* @__PURE__ */ e.jsx(
          I,
          {
            ref: u,
            placeholder: "Search...",
            value: t,
            onValueChange: c,
            disabled: s
          }
        ),
        /* @__PURE__ */ e.jsx(q, { children: t ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center", children: [
          "No results found.",
          /* @__PURE__ */ e.jsx(
            E,
            {
              variant: "link",
              onClick: () => {
                c(""), u.current?.focus();
              },
              children: "Clear search"
            }
          )
        ] }) : "Start typing to search" }),
        s ? /* @__PURE__ */ e.jsx("div", { className: "p-4 text-sm", children: o.message === "NOT_BUILT_YET" ? /* @__PURE__ */ e.jsxs(P, { type: "info", children: [
          "Search is currently not available in development mode by default.",
          /* @__PURE__ */ e.jsx("br", {}),
          "To still use search in development, run ",
          /* @__PURE__ */ e.jsx("code", { children: "zudoku build" }),
          " ",
          "and copy the ",
          /* @__PURE__ */ e.jsx("code", { children: "dist/pagefind" }),
          " directory to your",
          " ",
          /* @__PURE__ */ e.jsx("code", { children: "public" }),
          " directory."
        ] }) : "An error occurred while loading search." }) : /* @__PURE__ */ e.jsx(
          H,
          {
            searchResults: b ?? [],
            searchTerm: t,
            onClose: a,
            maxSubResults: n.maxSubResults
          }
        )
      ]
    }
  );
}, se = (r) => ({
  renderSearch: ({ isOpen: a, onClose: n }) => /* @__PURE__ */ e.jsx(k, { children: /* @__PURE__ */ e.jsx(Y, { isOpen: a, onClose: n, options: r }) })
});
export {
  se as pagefindSearchPlugin
};
//# sourceMappingURL=zudoku.plugin-search-pagefind.js.map
